<script setup lang="ts">
import type { PartnerAuthenticationTypeSlug } from '@/types/types'

defineProps<{ authType: PartnerAuthenticationTypeSlug; isLoading: boolean }>()

const { t } = useI18n()

const emit = defineEmits<{ (e: 'onClick'): void }>()
</script>

<template>
  <div class="mx-auto max-w-lg p-6 text-center text-sm">
    <BaseIcon name="HeroArrowPathIconOutline" class="mx-auto mb-2 w-6" />
    <h3 class="mb-2 font-bold">{{ t('pages.loyalty.create.emptyDevices.title') }}</h3>
    <p class="mb-2 text-foreground-secondary">
      {{
        authType === 'time-limited-token'
          ? t('pages.loyalty.create.emptyDevices.associate')
          : t('pages.loyalty.create.emptyDevices.description')
      }}
    </p>
    <div class="flex items-center justify-center gap-2">
      <span class="cursor-pointer font-bold text-primary underline" @click="emit('onClick')">{{
        t('pages.loyalty.create.emptyDevices.button')
      }}</span>
      <span v-if="isLoading" class="h-4 w-4">
        <Spinner size="sm" />
      </span>
    </div>
  </div>
</template>
